import { noop } from '@saaga/shared/utils/noop.util'
import type { FC, ReactNode } from 'react'

import { InlineEditableText } from '@/components/atoms/inline-editable-text.atom'

export interface ChatHeaderTitleSectionProps {
  title: string
  isEditing?: boolean
  isLoading?: boolean
  onEditStart?: () => void
  onSave?: (newName: string) => void
  onCancel?: () => void
}

/**
 * Title section of the chat header with inline edit capability.
 * Shows title with edit button in view mode, transforms to input in edit mode.
 */
export const ChatHeaderTitleSection: FC<ChatHeaderTitleSectionProps> = ({
  title,
  isEditing = false,
  isLoading = false,
  onEditStart,
  onSave,
  onCancel,
}): ReactNode => (
  <div className="chat-header-title-section hidden min-w-0 items-center gap-1 md:flex">
    <InlineEditableText
      value={title}
      isEditing={isEditing}
      isLoading={isLoading}
      onEditStart={onEditStart}
      onSave={onSave ?? noop}
      onCancel={onCancel ?? noop}
    />
  </div>
)

ChatHeaderTitleSection.displayName = 'ChatHeaderTitleSection'
